<template>
    <div class="exception-view">
        <div class="left-view">
            <ele-icon403></ele-icon403>
        </div>
        <div class="right-view">
            <el-descriptions title="企业已下架" :border="true" :column="1">
                <span slot="extra" style="color: #007aff;">如您确需该企业产品，请致电企业办理上架服务</span>
                <el-descriptions-item label="企业名称">{{ compInfo.compName }}</el-descriptions-item>
                <el-descriptions-item label="联系方式">{{ compInfo.phone }}</el-descriptions-item>
                <el-descriptions-item
                    :label="item.CSName || item.NickName"
                    v-for="(item, index) in customerList"
                    :key="index"
                >{{ item.Phone }}</el-descriptions-item>
            </el-descriptions>
        </div>
    </div>
</template>

<script>
import { CompService } from "@/service";
import {  decryptPhone } from "@/utils/utils";

import EleIcon403 from './403.vue';
export default{
    components: { EleIcon403 },
    data() {
        return {
            compInfo: {},
            customerList: [],
        }
    },
    mounted() {
        this.compId = this.$route.params.id;
        this.getCompInfo();
        this.getStaffcustomerlist();
    },
    methods: {
        async getCompInfo() {
            const res = await CompService.getCompanyInfo(this.compId);
            if (res.code === 0) {
                this.compInfo = res.data;
            }
        },
        async getStaffcustomerlist() {
            const res = await CompService.GetPublicUsers(this.compId);
            if (res) {
                res.forEach(item => {
                    item.Phone = decryptPhone(item.PhoneEncrypt);
                });
                this.customerList = res || [];
            }
        }
    },
}
</script>

<style lang="less" scoped>
    .exception-view{
        min-height: 80vh;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        margin: 0 auto;
        /deep/ .el-descriptions{
            margin-top: 16px;
        }
        /deep/ .el-descriptions__extra{
            color: #00000073;
        }
        /deep/ .el-descriptions__title{
            color: #000000d9;
            font-size: 24px;
        }
        .left-view{
            width: 252px;
            margin-right: 48px;
        }
        .right-view{
            width: 500px;
        }
    }
    .result-title{
        color: #000000d9;
        font-size: 24px;
        line-height: 1.8;
    }
    .result-subtitle {
        color: #00000073;
        font-size: 14px;
        line-height: 1.6;
    }
</style>